export * from './FilledCheckmarkSmallIcon'
